import { mapMutations, mapGetters, mapActions } from "vuex";
import { maxLength, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "change-name-form",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                name: "",
                second_name: "",
                last_name: "",
            },
            url: null,
            isEdit: false,
            showLoader: false,
            validationErrors: {},
        };
    },
    validations() {
        return {
            payload: {
                name: {
                    minLength: minLength(3),
                    maxLength: maxLength(20),
                },
                second_name: {
                    minLength: minLength(3),
                    maxLength: maxLength(20),
                },
                last_name: {
                    minLength: minLength(3),
                    maxLength: maxLength(20),
                },
            },
        };
    },
    created() {
        if (this.user) {
            this.payload.name = this.user.name;
            this.payload.second_name = this.user.second_name;
            this.payload.last_name = this.user.last_name;
        }
    },
    mounted() {
        this.cachedUser = Object.assign({}, this.payload);
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
            isEditProfileData: "profile/editProfileData",
            updateUserDataLoading: `profile/updateUserLoading`,
        }),
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        secondNameErrors() {
            let error = [];
            if (!this.$v.payload.second_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.second_name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.second_name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.second_name) {
                this.validationErrors.second_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        lastNameErrors() {
            let error = [];
            if (!this.$v.payload.last_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.last_name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.last_name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.last_name) {
                this.validationErrors.last_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.name === "" && this.payload.second_name === "" && this.payload.last_name === "") {
                return true;
            }
            if (
                this.payload.name === this.user.name &&
                this.payload.second_name === this.user.second_name &&
                this.payload.last_name === this.user.last_name
            ) {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions({
            updateUserData: `profile/UPDATE_USER_DATA`,
            addUserIcon: `profile/ADD_USER_ICON`,
            fetchUserData: `profile/FETCH_USER_DATA`,
        }),
        ...mapMutations({
            changeEditProfileData: `profile/CHANGE_EDIT_PROFILE_DATA`,
        }),
        cancel() {
            this.payload = Object.assign({}, this.cachedUser);
            this.isEdit = false;
        },
        onFileChange(e) {
            const file = e.target.files[0];
            this.url = URL.createObjectURL(file);
            let formData = new FormData();
            formData.append("image", file);
            this.addUserIcon(formData)
                .then(() => {
                    this.isEdit = false;
                    this.$toasted.success(this.$t("successAddUserPhoto"));
                    this.fetchUserData();
                    this.showLoader = false;
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.$toasted.error("failAddUserPhoto");
                        this.showLoader = false;
                    }
                });
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.showLoader = true;
                this.updateUserData(this.payload)
                    .then(() => {
                        this.isEdit = false;
                        this.$toasted.success(this.$t("successChangeData"));
                        this.showLoader = false;
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.$toasted.error(this.$t("failChangeData"));
                            this.showLoader = false;
                        }
                    });
            }
        },
    },
};
